// extracted by mini-css-extract-plugin
module.exports = {"container":"PastEvent_Playback_container__ccH4c","video":"PastEvent_Playback_video__2eFkK"};